export const normalizeAutocompleteValue = (value) =>
  String(value ?? "")
    .trim()
    .toLocaleLowerCase();

export const filterAutocompleteOptions = (
  options = [],
  search = "",
  limit = 8,
) => {
  const query = normalizeAutocompleteValue(search);

  if (!query) return [];

  return options
    .filter((option) =>
      normalizeAutocompleteValue(option.label).includes(query),
    )
    .sort((a, b) => {
      const aStarts = normalizeAutocompleteValue(a.label).startsWith(query);

      const bStarts = normalizeAutocompleteValue(b.label).startsWith(query);

      if (aStarts !== bStarts) {
        return aStarts ? -1 : 1;
      }

      return String(a.label).localeCompare(String(b.label));
    })
    .slice(0, limit);
};

export const findAutocompleteOption = (options = [], value = "") =>
  options.find(
    (option) =>
      normalizeAutocompleteValue(option.value) ===
        normalizeAutocompleteValue(value) ||
      normalizeAutocompleteValue(option.label) ===
        normalizeAutocompleteValue(value),
  ) || null;

export const isValidAutocompleteValue = (options = [], value = "") =>
  Boolean(findAutocompleteOption(options, value));
